import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const MarketSurveyParameterList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [itemList, setItemList] = useState([]);
  const [controlType, setControlType] = useState("");

  const { sendRequest: getMarketSurveyHeadField } = useHttp();

  const getMarketSurveyHeadFieldDetail = () => {
    getMarketSurveyHeadField(
      {
        url: `/api/marketSurveyHeadFieldList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getMarketSurveyHeadFieldDetail();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, marketSurveyHeadListId) => {
    e.preventDefault();

    // const data = {
    //   marketSurveyHeadListId: marketSurveyHeadListId,
      
    // };

    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Market Survey detail?",
      onOk() {
        deleteOperation(
          {
            url: `/api/marketSurveyHeadFieldList/?orgId=${localStorage.getItem(
                "orgId"
              )}&marketSurveyHeadListId=${marketSurveyHeadListId}&serviceId=${serviceId}`,
            method: "DELETE",
            
          },
          (data) => {
            if (data.success) {
              toast.success(data.success);
            }

            if (data.error) {
              toast.error(data.error);
            }
            getMarketSurveyHeadFieldDetail();
          }
        );
      },
      onCancel() {},
    });
  };
  const handleSearch = (e) => {
   var filtertext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.marketSurveyHeadName.toLowerCase().includes(filtertext) ||
        item.marketSurveyFieldName.toLowerCase().includes(filtertext) ||
        item.controlType.toLowerCase().includes(filtertext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
      // height: "80%",
      minHeight: "300px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (id) => {
    if (id) {
      getMarketSurveyHeadField(
        {
          url: `/api/marketSurveyHeadFieldList/?marketSurveyHeadListId=${id}&orgId=${localStorage.getItem(
            "orgId"
          )}`,
        },
        (res) => {
          if (res) {
            setSelectedData(res);
            setControlType(res.controlType);
            if (res.itemList) {
              setItemList(res.itemList);
            }
          }
        }
      );
    }
    setIsModalOpen(true);
  };
   const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);



  return (
    <>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Market Survey Details{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3">
            <button
              type="button"
              className="btn  btn-primary ml-5 my-2"
              onClick={() => {
                addForm(true);
                props.sId(serviceId || 0);
                props.update(false);
              }}
            >
              Add Market Survey
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Market Survey Head Name</th>
                            <th>Market Survey Field Name</th>
                            <th>Control Type</th>
                            <th>Status</th>
                            <th>View</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.marketSurveyHeadName}</td>
                                <td>{x.marketSurveyFieldName}</td>
                                <td>{x.controlType}</td>
                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      openModal(x.marketSurveyHeadListId)
                                    }
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) =>
                                      handleDelete(e, x.marketSurveyHeadListId)
                                    }
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Market Survey Detail</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Market Survey Head Name: {selectedData.marketSurveyHeadName}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Control Type: {selectedData.controlType}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Market Survey Field Name: {selectedData.marketSurveyFieldName}
              </p>
            </div>
            <div className="row">
              {controlType === "List" || controlType === "RadioButton" ? (
                <table className="table tabel-sm text-center table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Item Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemList.length > 0 ? (
                      itemList.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                <p></p>
              )}
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default MarketSurveyParameterList;
